import { BaseError } from 'make-error';

/**
 * A custom error type to be used when some sort of
 * token retrieval fails on a player.
 */
export class PlayerTokenError extends BaseError {
    constructor(message?: string) {
        super(message || 'A player token error occurred');
    }
}

/**
 * A custom error to be thrown when an ad widget sends a 'good'
 * response with no ad content, indicating there was no content scheduled
 * for a particular screen at that moment.
 */
export class NoNewContentError extends BaseError {
    constructor(message?: string) {
        super(message || 'No new content');
    }
}
